import styled from 'styled-components'

import { color } from 'theme/utils'

export const Layout = styled.div`
  background: ${color('background')};
  display: flex;
  flex-direction: column;
  min-height: var(--vh);
  width: 100%;
  &.offset {
    background: transparent;
    margin-top: 380px;
    min-height: calc(var(--vh) - 380px);
  }
`
